/**
 * The file used for the noisy audio input notification.
 *
 * @type {string}
 */
export const NOISY_AUDIO_INPUT_SOUND_FILE = 'noisyAudioInput.mp3';
